import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidRecognizeShortestForm } from '../../../../mechanics/rid-recognize-shortest-form/rid-recognize-shortest-form';

@Component({
  selector: 'app-recognize-shortest-form-page',
  imports: [RidRecognizeShortestForm],
  templateUrl: './recognize-shortest-form-page.html',
})
export class RecognizeShortestFormPage {
  protected readonly $router = inject(Router);
}
